import { render, staticRenderFns } from "./UsuarioDetalhar.vue?vue&type=template&id=42d18541&"
import script from "./UsuarioDetalhar.vue?vue&type=script&lang=js&"
export * from "./UsuarioDetalhar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports